import React from 'react';
import { SelectField } from 'is24-corecss';
import { useTranslation } from 'react-i18next';
import { BusinessType } from '../../api/tvs/uploadSessions/model/UploadSession';

export const companyFormOptionKeys = [
  'UNSPECIFIED',
  'NO_REGISTER_ENTRY',
  'REGISTERED_MERCHANT',
  'KG',
  'GMBH_CO_KG',
  'OHG',
  'EGBR',
  'AG',
  'SE',
  'GMBH',
  'G_GMBH',
  'UG',
  'PART_G',
  'PART_G_MBB',
  'ANSTALT_OEFFENTLICHEN_RECHTS',
  'KOERPERSCHAFT_OEFFENTLICHEN_RECHTS',
  'EG',
  'EV',
  'STIFTUNG',
  'ANDERE_GESELLSCHAFTSFORM',
] as const satisfies readonly BusinessType[];

export type CompanyFormOptionKey = (typeof companyFormOptionKeys)[number];

export const defaultCompanyFormOption: CompanyFormOptionKey = 'UNSPECIFIED';

interface CompanyFormSelectProps {
  value: CompanyFormOptionKey;
  onChange: (value: CompanyFormOptionKey) => void;
  hasError?: boolean;
  errorMessage?: string;
  disabled?: boolean;
}

const CompanyFormSelect: React.FC<CompanyFormSelectProps> = ({
  value,
  onChange,
  hasError = false,
  errorMessage,
  disabled = false,
}) => {
  const { t } = useTranslation();

  return (
    <SelectField
      id='company-form'
      label={t('KybLandingPage.companyFormLabel1')}
      value={value}
      isErroneous={hasError}
      captionText={hasError ? errorMessage : undefined}
      disabled={disabled}
      onChange={(event) => onChange(event.target.value as CompanyFormOptionKey)}
    >
      {companyFormOptionKeys.map((option) => (
        <option key={option} value={option}>
          {t(`CompanyFormSelect.options.${option}`)}
        </option>
      ))}
    </SelectField>
  );
};

export default CompanyFormSelect;
